var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/img/nudgd.png")}}),(_vm.$store.state.errorMessage)?_c('h2',[_vm._v(_vm._s(_vm.$store.state.errorMessage))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }